// Template for /partnerships/<slug> pages.
// Converted from https://www.dbos.dev/partnerships/bauplan.

import type { Partnership } from '@content/types';
import { SiteLayout } from '@components/layout/SiteLayout';
import { FooterCtaBuildYourReliableBackend } from '@components/layout/FooterCtas';
import { Img } from '@components/cms/Img';
import { SlideIn } from '@components/interactions';
import { cx } from '@components/webflow/element';

export function PartnershipPage({
  partner,
  body,
  resources,
}: {
  partner: Partnership;
  body: string;
  resources: string;
}) {
  return (
    <SiteLayout banner={true} footerCta={<FooterCtaBuildYourReliableBackend />}>
      <section className="section_partner">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-small margin-bottom">
              <div className="max-width-xlarge is-partner">
                <div className="partner_component">
                  <div className="partner_sidebar">
                    <div className="margin-bottom margin-breadcrumb">
                      <div className="div-block-72">
                        <a href="/partners" className="button tertiary-large-15 w-inline-block">
                          <div className="icon-arrow-left tertiary-large-16 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M10.5892 5.58917L9.41083 4.41084L3.82167 10L9.41083 15.5892L10.5892 14.4108L7.01167 10.8333L15 10.8333L15 9.16667L7.01167 9.16667L10.5892 5.58917Z"
                                fill="var(--_color-scheme-july-2025---headings)"
                              />
                              {'\n'}
                            </svg>
                          </div>
                          <div className="text-block-4 tertiary-large-17">Back to partners</div>
                        </a>
                      </div>
                    </div>
                    <div className="margin-bottom margin-small">
                      <div className="partner_header">
                        <div className="partner_logo-wrapper">
                          <Img image={partner.logo} loading="lazy" className="partner_logo" />
                        </div>
                        <h3 className="heading-style-h5">{partner.name}</h3>
                        <div className="partner_attribute">
                          <div className="text-size-regular text-weight-regular">Industry</div>
                          <div className="text-body-active text-size-regular">{partner.industry}</div>
                        </div>
                        <div className="partner_attribute">
                          <div className="text-size-regular text-weight-regular">Website</div>
                          <a
                            target="_blank"
                            className="text-body-active text-size-regular is-partner"
                            href={partner.website}
                          >
                            {partner.website}
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="partner_header">
                      <h3 className="heading-style-h5">Get started for free</h3>
                      <div className="text-body-active text-size-regular">
                        Launch your reliable software in minutes.
                      </div>
                      <div className="button-group is-partner">
                        <div data-wf--button--variant="primary-large" className="button-wrapper">
                          <a href="https://console.dbos.dev/" className="button w-inline-block">
                            <div className="text-block-4">Start building</div>
                            <div className="icon-chevron-right w-embed">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </a>
                        </div>
                        <div
                          data-wf--button--variant="secondary-large"
                          className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                        >
                          <a
                            href="https://calendly.com/alex-poliakov-dbos/30min"
                            className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                          >
                            <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">
                              Book a demo
                            </div>
                            <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_54c4a702-8c1a-2325-d2e5-f8979491901b-e96f407a"
                    className="max-width-xlarge is-column"
                  >
                    <div className="margin-bottom margin-small">
                      <div className="w-embed">
                        <h1 className="heading-style-h2">{partner.heading}</h1>
                      </div>
                    </div>
                    <div className="margin-bottom margin-small">
                      <div
                        className={cx('text-body-rich w-richtext', !body && 'w-dyn-bind-empty')}
                        fs-toc-element="contents"
                        dangerouslySetInnerHTML={{ __html: body }}
                      />
                    </div>
                    <div className="margin-bottom margin-tiny">
                      {resources && <h3 className="heading-style-h5">Resources</h3>}
                    </div>
                    <div
                      className={cx('text-rich-resources w-richtext', !resources && 'w-dyn-bind-empty')}
                      dangerouslySetInnerHTML={{ __html: resources }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
    </SiteLayout>
  );
}
